/**
 * Shared default nav items for canvas previews.
 *
 * Mirrors the live Navbar's featureConfig fallback (buildNav in
 * frontend/app/app/lib/tenant.tsx) which renders enabled features in
 * fixed order. These representative labels keep the canvas header from
 * showing a bare strip for un-configured tenants.
 */
export interface CanvasNavItem {
  key: string;
  label: string;
  primary: boolean;
}

export const DEFAULT_CANVAS_NAV: CanvasNavItem[] = [
  { key: "default-home", label: "Home", primary: false },
  { key: "default-about", label: "About", primary: false },
  { key: "default-blog", label: "Blog", primary: false },
  { key: "default-contact", label: "Contact", primary: false },
  { key: "default-book", label: "Book now", primary: true },
];
